<template>
    <div :id="id" class="form-cadastro-modelo">
      <ul class="modal-tabs has-text-weight-bold">
        <li>
          <a
            id="tab-cadastro"
            :class="{
              'is-active': tabSelecionada == 'cadastro' || tabSelecionada == ''
            }"
            @click="tabSelecionada = 'cadastro'"
            ><span>Cadastro &nbsp;</span>
          </a>
        </li>
        <li v-if="checkFase && camposPermitidos.fases">
          <a id="tab-fase" :class="{ 'is-active': tabSelecionada == 'fase' }" @click="tabSelecionada = 'fase'">
            <span>&nbsp; Fases</span>
          </a>
        </li>
      </ul>
  
      <form>
        <div v-show="tabSelecionada == 'cadastro' || tabSelecionada == ''">
          <div class="notification is-info is-light px-3 py-2">
            Neste modal será possível importar um novo modelo ao cadastro da sua tarefa e/ou editar as fases já cadastradas.
          </div>
          <div class="columns is-flex">
            <div>
                <TrfCheckbox
                label="Importar modelo"
                id="checkbox-importacao"
                v-model="isSelectModeloOpen"
                @change="limparInputsCadastroModelo"
                class="column is-12-mobile is-align-self-center"
                tituloTip='Selecione esta opção se deseja importar um modelo cadastrado no módulo "Cadastro de modelos"'
              />
            </div>
          </div>

          <div class="columns is-align-items-flex-end" v-if="isSelectModeloOpen">
            <div class="column is-four-fifths is-align-content-center pt-0">
                <span class="tip-label is-size-7"> <i> Apenas modelos de departamentos para os quais você tem permissão serão exibidos.</i></span>
                <TrfSelect
                class="is-fullWidth is-align-self-center"
                v-if="isSelectModeloOpen"
                :options="listaDeModelosExibicao"
                :noOptionsText="'Modelo(s) não encontrado(s)'"
                label="Selecione um modelo"
                idSelect="select-modelo-nova-tarefa"
                @valueSelect="selecionarModelo"
                @clear="limparSelectModelo"
                placeholder="Selecione"
                ref="selectModelo"
                :canClear="true"
              >
                <template #erroMessage>
                  <span class="campo-obrigatorio" style="display: block; margin-bottom: -18px;">Selecione um modelo para importar na sua tarefa.</span>
                </template>
              </TrfSelect>
            </div>
            <div class="column is-align-content-center mb-4">
              <label class="is-invisible mb-3">Importar</label>
              <TrfButton
                class="is-fullWidth is-primary"
                id="btn-importar-modelo"
                :temIcon="true"
                classIcon="mdi-arrow-down"
                nome="Importar"
                type="button"
                :disabled="modeloSelecionado == null"
                @click="verificarImportacaoDeModelo"
              />
            </div>
          </div> 
          <TrfInput label="Nome" placeholder="Nome da tarefa" id="nome-tarefa" maxLength="100" ref="inputNome" v-model="tarefa.nome" :is-disabled="true"/>
          <div class="container-descricao">
            <label>
              Descrição
              <span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="loading.campoDescricao"></span>
            </label>
            <TrfToolbarTextEditor
              tipLabel="Adicione informações complementares ao modelo, caso necessário."
              :disabled="true"
              @changeText="(value) => (tarefa.descricao = value)"
              @ready="($event) => (loading.editorDeTexto = $event)"
              ref="textEditor"
            />
          </div>
          <TrfSelect
            :options="responsaveisOptions"
            label="Responsável"
            idSelect="select-responsavel-novo-modelo"
            @valueSelect="(value) => (tarefa.responsavel = value)"
            @clear="($event) => (tarefa.responsavel = '')"
            placeholder="Selecione o responsável pelo modelo"
            ref="selectResponsavel"
            :canClear="true"
            :disabled="true"
            :loadingData="loadingResponsaveis"
            :required="false"
          />
          <div class="container-departamento">
            <TrfSelect
              label="Departamento"
              :options="listaDeDepartamentos"
              idSelect="select-departamento-nova-modelo"
              @valueSelect="(value) => (tarefa.departamento = value)"
              placeholder="Selecione"
              ref="selectDepartamento"
              :disabled="true"
              :loadingData="loadingDepartamentos"
            />
          </div>
  
          <div class="is-flex">
            <TrfCheckbox label="Gera multa por atraso" id="checkbox-gera-multa" v-model="geraMulta" class="mr-4" style="flex-shrink: 0" :disabled="true" />
            <div class="ml-4">
              <TrfCheckbox label="Fases" id="checkbox-fase" v-model="checkFase" @update:modelValue="tratarToggleFase" :disabled="!podeEditarFase" />
            </div>
          </div>
  
          <div class="notification is-info is-light px-3 py-2" v-if="checkFase">
            A aba fases foi habilitada para que possa incluir as fases necessárias.
          </div>
        </div>
        <div v-if="checkFase && camposPermitidos.fases" v-show="tabSelecionada == 'fase' || tabSelecionada == ''" class="pb-5">
          <TrfCadastroDeFases
            ref="cadastroDeFases"
            :isEnabled="checkFase"
            :responsaveis="listaDeResponsaveis"
            :listaDepartamentosFase="listaDepartamentosFase"
            :atributosCadastro="this.atributosCadastro"
            :listagemRecebida="tarefa?.fases != null ? tarefa.fases : []"
            :tiposDeBaixa="['manual', 'personalizada']"
            :utilizaAutoComplete="false"
            :isEdicao="isEdicaoComFase"
            @update:lista-fases="($event) => definirFasesTarefa($event)"
            @error:objeto-invalido="($event) => definirErroFaseInvalida($event)"
            @error:fases-ordem-invalida="($event) => definirErroOrdemFaseInvalida($event)"
          ></TrfCadastroDeFases>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import { defineAsyncComponent } from 'vue';
  import { toastUtils } from '../../util/toast.utils.js';
  import Tarefa from '../../views/CadastroTarefas/model/tarefa.js'
  import { origemTarefaEnum } from '../../enums/origemTarefaEnum.js';
  
  export default {
    name: 'TrfFormularioEdicaoAvulsa',
    components: {
      TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
      TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
      TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
      TrfToolbarTextEditor: defineAsyncComponent(() => import('.././ToolbarTextEditor/index.vue')),
      TrfCadastroDeFases: defineAsyncComponent(() => import("../CadastroDeFases/index.vue")),
      TrfCheckbox: defineAsyncComponent(() => import('../Checkbox/index.vue')),
      TrfButton: defineAsyncComponent(() => import('../Button/index.vue'))
    },
    emits: ['update:values', 'submit:error', 'ativarConfirmacaoEdicao', 'isModeloImportado'],
    props: {
      id: {
        type: [String],
        default: 'trf-edicao-tarefa-avulsa'
      },
      tarefaEmEdicao: {
        type: [Object],
        default: null
      },
      listaDeResponsaveis: {
        type: [Array],
        default: new Array()
      },
      loadingResponsaveis: {
        type: [Boolean],
        default: true
      },
      listaDeDepartamentos: {
        type: [Array],
        default: new Array()
      },
      listaDepartamentosFase: {
        type: [Array],
        default: new Array()
      },
      listaDeModelos: {
        type: [Array],
        default: new Array()
      },
      listaDeModelosExibicao: {
        type: [Array],
        default: new Array()
      },
      loadingDepartamentos: {
        type: [Boolean],
        default: true
      },
    },
    data() {
      return {
        tabSelecionada: 'cadastro',
        tarefa: this.tarefaEmEdicao? JSON.parse(JSON.stringify(this.tarefaEmEdicao)) : new Tarefa(),
        isSelectModeloOpen: false,
        checkFase: false,
        isFasesValidas: false,
        isOrdemFasesValidas: false,
        modeloIdSelecionado: '',
        modeloSelecionado: null,
        loading: {
          campoDescricao: false
        },
        camposPermitidos: {
          fases: false
        },
        geraMulta: false,
        atributosCadastro :{
          departamentoId: null
        }
      }
    },
    watch: {
      tarefa: {
        immediate: true,
        handler(novosDados, velhosDados) {
          if (!this.tarefaEmEdicao || this.tarefa == null) return;
          const tarefaTratada = {
            id: this.tarefaEmEdicao.id,
            nome: novosDados.nome,
            geraMulta: !!novosDados.geraMulta,
            responsavelId: novosDados.responsavelId,
            nomeResponsavel: novosDados.responsavel,
            departamentoId: novosDados.departamentoId,
            nomeDepartamento: novosDados.departamento,
            empresaId: novosDados?.empresa?.id,
            descricao: novosDados.descricao? novosDados.descricao : ''
          };

          if (this.podeEditarNome(this.tarefaEmEdicao) && !!this.modeloSelecionado) {
            tarefaTratada.nome = this.modeloSelecionado?.nome
          }

          if (!!this.modeloSelecionado) {
            tarefaTratada.idModelo = this.modeloSelecionado?.id
          }
          if(!!novosDados.fases) {
            tarefaTratada.fases = [];
            novosDados.fases.forEach(fase => {
              const faseRequest = {
                ordem: fase.ordem,
                nome: fase.nome,
                responsavelId: fase.responsavelId,
                departamentoId: !!!fase?.departamentoId ? tarefaTratada?.departamentoId : fase?.departamentoId,
                descricao: fase.descricao
              }
              if (fase.uuid) {
                faseRequest.uuid = fase.uuid;
              }
              if (fase.referenciaBaixaPersonalizada) {
                faseRequest.referenciaBaixaPersonalizada = fase.referenciaBaixaPersonalizada;
              }
              if (fase.documentosReferencias) {
                faseRequest.documentosReferencias = fase.documentosReferencias;
              }
              tarefaTratada.fases.push(faseRequest);
            })
          } else {
            tarefaTratada.fases = []
          }

          this.$emit('update:values', tarefaTratada) 
        },
        deep: true
      },
      tarefaEmEdicao: {
        immediate: true,
        handler(novosDados, velhosDados) {
          if (!novosDados || novosDados.id == "" || novosDados.id == velhosDados?.id || JSON.stringify(novosDados) == JSON.stringify(this.tarefa)) return;
          this.tarefa = JSON.parse(JSON.stringify(novosDados));
          this.camposPermitidos.fases = !novosDados?.fases; 
          this.carregarTarefaParaEdicao(novosDados); 
        },
        deep: true
      },
      loadingDepartamentos: {
        immediate: true,
        handler(novosDados, velhosDados) {
          if (novosDados == true) return;
          this.selecionarDepartamento(this.tarefa.departamentoId);
          this.tarefa = JSON.parse(JSON.stringify(this.tarefa));
        }
      },
      loadingResponsaveis: {
        immediate: true,
        handler(novosDados, velhosDados) {
          if (novosDados == true) return;
          this.selecionarResponsavel(this.tarefa.responsavelId);
          if(Array.isArray(this.tarefa?.fases) && this.tarefa.fases.length > 0) {
            this.checkFase = true;
          }
          this.tarefa = JSON.parse(JSON.stringify(this.tarefa));
        }
      }
    },
    computed: {
      responsaveisOptions() {
        return this.listaDeResponsaveis;
      },
      podeEditarFase() {
        return !!this.tarefaEmEdicao?.fases || !!this.tarefaEmEdicao?.complementoTarefa?.fases || !!this.modeloSelecionado?.complementoTemplate?.fasesTemplates;
      },
      isEdicaoComFase() {
        return !!this.tarefaEmEdicao && !!this.tarefaEmEdicao.id && (this.tarefaEmEdicao?.fases != null || Array.isArray(this.modeloSelecionado?.complementoTemplate?.fasesTemplates));
      }
    },
    methods: {
      podeEditarNome(tarefa) {
        return origemTarefaEnum.NENHUMA.equals(tarefa.origemTarefa);
      },
      podeEditarDescricao(tarefa) {
        return !origemTarefaEnum.ATENDIMENTO.equals(tarefa.origemTarefa);
      },
      async selecionarDepartamento(departamentoId) {
        await this.$nextTick();
        await this.$nextTick();
        if (departamentoId && departamentoId != "" && this.$refs.selectDepartamento) {
          this.$refs.selectDepartamento.iniciarSelectComValor(departamentoId.toString());
        }
      },
      async selecionarResponsavel(responsavelId) {
        await this.$nextTick();
        await this.$nextTick();
        if (responsavelId && responsavelId != "" && this.$refs.selectResponsavel) {
          this.$refs.selectResponsavel.iniciarSelectComValor(responsavelId);
        } else if (this.$refs.selectResponsavel) {
          this.$refs.selectResponsavel.limparSelect();
        }
      },
      carregarTarefaParaEdicao(tarefa) {
        this.tarefa.nome = tarefa.nome;
        this.tarefa.descricao = this.$refs.textEditor.iniciarTextEditorComValor(
          tarefa.observacoes
        );
        if (!this.loadingDepartamentos) {
          this.selecionarDepartamento(tarefa.departamentoId);
        };
        if (!this.loadingResponsaveis) {
          this.selecionarResponsavel(tarefa.responsavelId);
        };
        if (!this.loadingResponsaveis && Array.isArray(tarefa?.fases) && tarefa.fases.length > 0) {
          this.tarefa.fases = [...tarefa.fases];
          this.camposPermitidos.fases = true;
          this.checkFase = true;
        } else {
          this.tarefa.fases = []
          this.camposPermitidos.fases = false;
          this.checkFase = false;
        }
        this.tarefa.geraMulta = tarefa.geraMulta;
        this.geraMulta = tarefa.geraMulta;
        this.atributosCadastro.departamentoId = tarefa.departamentoId;
      },
      isFasesAtivas() {
        return this.checkFase;
      },
      definirErroFaseInvalida(resultado) {
        this.isFasesValidas = !resultado
      },
      definirErroOrdemFaseInvalida(resultado) {
        this.isOrdemFasesValidas = !resultado
      },
      definirFasesTarefa(valor) {
        this.tarefa.fases = [...valor];
      },
      tratarToggleFase() {
        if (this.checkFase && Array.isArray(this.modeloSelecionado?.complementoTemplate?.fasesTemplates)) {
          this.tarefa.fases = [...this.this.modeloSelecionado.complementoTemplate.fasesTemplates]
        } else if (this.checkFase) {
          this.tarefa.fases = this.isEdicaoComFase
            ? [...this.tarefaEmEdicao?.fases]
            : [];
        } else {
          this.$refs.cadastroDeFases.limparCamposFase();
          this.$refs.cadastroDeFases.limparListagemFases();
          this.tarefa.fases = [];
        }
      },
      checkValidity(mostrarErrorToast) {
        const isNomeValido = !this.$refs.inputNome.verificarSeInputEstaVazio();
        const isDepartamentoValido = !this.$refs.selectDepartamento.verificarSeInputEstaVazio();
  
        let isFasesValidas = !this.camposPermitidos.fases || !this.checkFase;
        let isFasesArrayValida = !this.camposPermitidos.fases || !this.checkFase;
        if (this.checkFase && this.camposPermitidos.fases) {
          isFasesArrayValida = Array.isArray(this.tarefa.fases) && this.tarefa.fases.length > 0;
          isFasesValidas = this.isOrdemFasesValidas && isFasesArrayValida;
        }
  
        if (mostrarErrorToast) {
          this.exibirErros(isNomeValido, isDepartamentoValido, isFasesValidas, isFasesArrayValida);
        }
  
        return isNomeValido && isDepartamentoValido && isFasesValidas;
      },
      exibirErros(validacaoNome, validacaoDepartamento, validacaoOrdemFase, validacaoFases) {
        if (!validacaoNome) {
          toastUtils.dangerToast('Nome inválido. Verifique.');
        } else if (!validacaoDepartamento) {
          toastUtils.dangerToast('Departamento inválido. Verifique.');
        } else if (!validacaoFases) {
          toastUtils.dangerToast('Adicione fases em sua tarefa.');
        } else if (!validacaoOrdemFase) {
          toastUtils.dangerToast('As fases devem ser cadastradas em sequência numérica. Verifique.');
        }
      },
      limparFormulario() {
        this.tarefa = new Tarefa();
        this.$refs.selectDepartamento.limparSelect();
        this.$refs.selectResponsavel.limparSelect();
        this.$refs.selectDepartamento.limparValidacao();
        this.$refs.selectResponsavel.limparValidacao();
        this.$refs.inputNome.limparValidacao();
        this.$refs.textEditor.limparCampo();
        if(this.checkFase) {
          this.$refs.cadastroDeFases.limparCamposFase();
          this.tarefa.fases = [];
          this.checkFase = false;
        }
        this.tabSelecionada = 'cadastro';
        for(let campo in this.camposPermitidos) {
          this.camposPermitidos[campo] = false;
        }
        if(!!this.$refs.selectModelo) {
          this.$refs.selectModelo.limparSelect();
          this.$refs.selectModelo.limparValidacao();
        }
        if (this.modeloImportado) {
          this.modeloImportado = !this.modeloImportado
        }
        this.isSelectModeloOpen = false;
        this.modeloIdSelecionado = '';
      },
      resetarFormulario() {
        if (this.modeloImportado) {
          this.modeloImportado = !this.modeloImportado
          this.modeloIdSelecionado = '';
          this.modeloSelecionado = null;
        }
        this.tarefa = JSON.parse(JSON.stringify(this.tarefaEmEdicao));
        this.camposPermitidos.fases = !this.tarefa?.fases; 
        this.carregarTarefaParaEdicao(this.tarefa); 
        this.tabSelecionada = 'cadastro';
      },
      limparInputsCadastroModelo() {
        if (this.modeloImportado) {
          this.$emit('ativarConfirmacaoEdicao', 'resetarModelo')
        }
      },
      selecionarModelo(id) {
        if (!id) return;
        this.modeloIdSelecionado = id;
        this.modeloSelecionado = this.listaDeModelos.find((x) => x.id === id);
      },
      limparSelectModelo() {
        if(this.modeloSelecionado != null) {
          this.modeloSelecionado = null;
          this.modeloIdSelecionado = '';
          this.$refs.selectModelo.limparSelect();
        }
      },
      verificarImportacaoDeModelo() {
        if (this.modeloSelecionado == null || this.modeloIdSelecionado == '') {
          this.$refs.selectModelo.verificarSeInputEstaVazio();
          return;
        };
        this.$refs.selectModelo.limparValidacao();
        this.$emit("ativarConfirmacaoEdicao", this.tarefaEmEdicao.origemTarefa);
      },
      importarModeloSelecionado() {
        if (this.podeEditarNome(this.tarefaEmEdicao)) {
          this.tarefa.nome = this.modeloSelecionado.nome;
        }
        
        if (this.podeEditarDescricao(this.tarefaEmEdicao)) {
          this.tarefa.descricao = this.$refs.textEditor.iniciarTextEditorComValor(
            this.modeloSelecionado.descricao
          );
          this.tarefa.descricao = this.modeloSelecionado.descricao;
        }

        let responsavelId = this.modeloSelecionado.responsavelId;
        this.tarefa.responsavelId = responsavelId;

        if (!!responsavelId) {
          this.$refs.selectResponsavel.selecionar(responsavelId);
          this.tarefa.responsavel = this.listaDeResponsaveis.find(responsavel => responsavel.value == responsavelId).label;
        } else {
          this.$refs.selectResponsavel.limparSelect();
          this.tarefa.responsavel = '';
        }

        let departamentoId = this.modeloSelecionado.departamentoId;
        if(!!departamentoId) {          
          this.tarefa.departamentoId = departamentoId;
          this.atributosCadastro.departamentoId = departamentoId;
          this.$refs.selectDepartamento.iniciarSelectComValor(departamentoId.toString());
          this.tarefa.departamento = this.listaDeDepartamentos.find(departamento => departamento.value == departamentoId).label;
        }
        
        this.tarefa.geraMulta = this.modeloSelecionado.geraMulta;
        this.geraMulta = this.tarefa.geraMulta;

        if (Array.isArray(this.modeloSelecionado.complementoTemplate?.fasesTemplates) && this.modeloSelecionado.complementoTemplate.fasesTemplates.length > 0) {
          this.checkFase = true;
          this.camposPermitidos.fases = true;
          this.tarefa.fases = [...this.modeloSelecionado.complementoTemplate.fasesTemplates];
        } else {
          this.checkFase = false;
          this.camposPermitidos.fases = false;
          this.tarefa.fases = [];
          this.isOrdemFasesValidas = true;
        }
        this.checkValidity();
        this.modeloImportado = true;
        this.$emit("isModeloImportado", this.modeloImportado)
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  #btn-adicionar {
    margin-right: 5px;
  }
  .content-fase {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.35s ease-in 0s, opacity 0.25s ease-in 0.1s;
    &.is-open {
      max-height: 1000vh;
      transition: max-height 0.35s ease-out 0s, opacity 0.25s ease-out 0.1s;
      opacity: 1;
      overflow: visible;
    }
  }
  .columns.is-form {
    .column {
      padding-bottom: 0 !important;
    }
  }
  .tip-label-grupo {
    font-style: italic;
    font-size: 12px;
  }
  </style>
  